export const AI_LISTERS_PATH = '/people/ai-lists';
export const AI_LISTERS_PRODUCT = 'ai_listers';

// One-shot in-memory signal: the "Modify with AI" button (and only it) makes AI Listers drop "explain this list" once; in-memory so a refresh or deep link never re-triggers it.
let pendingExplainSeed = false;
export const requestExplainSeed = (): void => {
  pendingExplainSeed = true;
};
export const consumeExplainSeed = (): boolean => {
  const requested = pendingExplainSeed;
  pendingExplainSeed = false;
  return requested;
};
